var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 545,
    height: 545,
    viewBox: "0 0 545 545",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFA",
    d: "M544.8,272.4 C544.8,422.842 422.843,544.799 272.401,544.799 C121.958,544.799 0,422.842 0,272.4 C0,121.958 121.958,0 272.401,0 C422.843,0 544.8,121.958 544.8,272.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    fillOpacity: 0.3,
    d: "M199.3739 191.5917C199.3739 224.4527 172.7349 251.0917 139.8739 251.0917 107.0129 251.0917 80.3739 224.4527 80.3739 191.5917 80.3739 158.7307 107.0129 132.0917 139.8739 132.0917 172.7349 132.0917 199.3739 158.7307 199.3739 191.5917M296.954 96.5917C296.954 117.6227 279.905 134.6717 258.874 134.6717 237.843 134.6717 220.794 117.6227 220.794 96.5917 220.794 75.5607 237.843 58.5117 258.874 58.5117 279.905 58.5117 296.954 75.5607 296.954 96.5917M293.2451 201.5917C293.2451 215.0517 282.3341 225.9627 268.8741 225.9627 255.4141 225.9627 244.5031 215.0517 244.5031 201.5917 244.5031 188.1317 255.4141 177.2207 268.8741 177.2207 282.3341 177.2207 293.2451 188.1317 293.2451 201.5917"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.d02c41756a7e66745e1a3b6271b71c8f.svg";
export { ForwardRef as ReactComponent };